import { useState, useCallback } from 'react';
import api from '../utils/api';

export function useClassLogs(studentId) {
  const [classLogs, setClassLogs] = useState({});
  const [loading, setLoading] = useState({});

  const fetchClassLogs = useCallback(async (eventId) => {
    if (!studentId || !eventId) return null;

    // Return cached if available
    if (classLogs[eventId] !== undefined) {
      return classLogs[eventId];
    }

    try {
      setLoading(prev => ({ ...prev, [eventId]: true }));
      const response = await api.get(
        `/parent/children/${studentId}/modules/${eventId}/class-logs`
      );
      const logs = response.data.class_logs;
      setClassLogs(prev => ({ ...prev, [eventId]: logs }));
      return logs;
    } catch (err) {
      console.error('Failed to fetch class logs:', err);
      setClassLogs(prev => ({ ...prev, [eventId]: null }));
      return null;
    } finally {
      setLoading(prev => ({ ...prev, [eventId]: false }));
    }
  }, [studentId, classLogs]);

  const isLoading = (eventId) => loading[eventId] || false;
  const getLogs = (eventId) => classLogs[eventId];

  return { fetchClassLogs, isLoading, getLogs };
}
